module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper7",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/cm1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('Our_clients')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Our_clients')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v("\n\n\t\t" + _vm._s(_vm.$t('Clients_text_01')) + ":\n\n\n\n\n\n\t\t"), _c('ul', [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Individuals')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Clients_text_02')) + ".\n\n\n\n\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Law_firms')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Auditors')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Clients_text_03')) + ".\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Private_Enterprises')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Financial_Entities')))]), _vm._v(".\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Clients_text_04')) + ".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Public_Administrations')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Mutual_insurance_companies')) + ", " + _vm._s(_vm.$t('Hospitals')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Medical_centers')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Cooperatives')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Foundations')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Property_developers')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Sports_clubs')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Insurance_companies')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Investment_groups')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Hotels')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Restaurants')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Others')))]), _vm._v(".")])])]), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ef288e52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/OurClients.vue
// module id = 2194
// module chunks = 0